import { CreateUserMutationProvider } from "__legacy/queries/users/CreateUserMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import { onError, onFinish, UserForm } from "./UserForm";

export const New: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <CreateUserMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
      {(loading, mutate) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title={`New user`}
            extra={
              <Fragment>
                <Button onClick={() => navigate("../")}>Back to list</Button>
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                  Save
                </Button>
              </Fragment>
            }
          />
          <Layout.Content className="content">
            <UserForm action="create" form={form} handler={onFinish(mutate, {}, {})} values={{}} errors={errors} />
          </Layout.Content>
        </Fragment>
      )}
    </CreateUserMutationProvider>
  );
};
